module.exports = __webpack_public_path__ + "img/banner_jiejuefangan.f60ac5c5.png";